import { getColor } from 'common/constants/_colors';
import { ClickableTextMixin } from 'components/base/common-styles';
import styled from 'styled-components';

export const StyledLegendSymbol = styled.div`
  width: 1rem;
  height: 1rem;
  border: 3px solid ${props => props.color};
  border-radius: 50%;
  background-color: ${props => (props.fill ? props.color : 'transparent')};
`;

export const StyledLegendMenuList = styled.ul`
  padding: 0;
  list-style-type: none;
`;

export const StyledLegendMenuItem = styled.li`
  display: flex;
  align-items: center;
  color: ${getColor('shark')};
  margin-bottom: 2rem;
  & ${StyledLegendSymbol} {
    margin-right: 1rem;
  }
  ${ClickableTextMixin};
`;

export const StyledMenuSubHeader = styled.div`
  margin-top: 4rem;
`;

export const StyledLegendMenu = styled.div`
  position: relative;
  bottom: 3rem;
`;
